// sidebarConfig.js
// SVG imports as components
import { ReactComponent as HomeIcon } from "../assets/svg/SidebarIcons/home-01.svg";
import { ReactComponent as CourseIcon } from "../assets/svg/SidebarIcons/courses-01.svg";
import { ReactComponent as InstructorIcon } from "../assets/svg/SidebarIcons/instructors-01.svg";
import { ReactComponent as StudentIcon } from "../assets/svg/SidebarIcons/students-01.svg";
import { ReactComponent as PaymentIcon } from "../assets/svg/SidebarIcons/payments-01.svg";
import { ReactComponent as MaterialIcon } from "../assets/svg/SidebarIcons/materials-01.svg";
import { ReactComponent as RefundIcon } from "../assets/svg/SidebarIcons/refunds-01.svg";
import { ReactComponent as RolesIcon } from "../assets/svg/SidebarIcons/roles.svg";
import { ReactComponent as PermissionsIcon } from "../assets/svg/SidebarIcons/permission.svg";
import { ReactComponent as BlogIcon } from "../assets/svg/SidebarIcons/blog.svg";
import { ReactComponent as RecordingsIcon } from "../assets/svg/SidebarIcons/recordings-icon.svg";
import { ReactComponent as CategoryIcon } from "../assets/svg/SidebarIcons/category-icon.svg";
import { ReactComponent as UserIcon } from "../assets/svg/SidebarIcons/users-icon.svg";
import { ReactComponent as LogoLV } from "../assets/svg/Logo.svg";

export const sidebarItems = [
  {
    to: "/dashboard/Home",
    icon: <HomeIcon />,
    label: "Home",
    permission: null, // No permission required for Home
  },
  {
    to: "/dashboard/categories",
    icon: <CategoryIcon />,
    label: "Categories",
    permission: "view_category",
  },
  {
    to: "/dashboard/placement-tests",
    icon: <CategoryIcon />,
    label: "Placement Test",
    permission: null,
  },
  {
    to: "/dashboard/courses",
    icon: <CourseIcon />,
    label: "Courses",
    permission: null,
  },
  {
    to: "/dashboard/users",
    icon: <UserIcon />,
    label: "Users",
    permission: "view_user",
  },
  {
    to: "/dashboard/instructors",
    icon: <InstructorIcon />,
    label: "Instructors",
    permission: "view_instructor",
  },
  {
    to: "/dashboard/students",
    icon: <StudentIcon />,
    label: "Students",
    permission: "view_student",
  },
  {
    to: "/dashboard/payments",
    icon: <PaymentIcon />,
    label: "Payments",
    permission: "view_payment",
  },
  {
    to: "/dashboard/materials",
    icon: <MaterialIcon />,
    label: "Materials",
    permission: "view_material",
  },
  {
    to: "/dashboard/refunds",
    icon: <RefundIcon />,
    label: "Refunds",
    permission: "view_refund",
  },
  {
    to: "/dashboard/roles",
    icon: <RolesIcon />,
    label: "Roles",
    permission: "view_role",
  },
  {
    to: "/dashboard/permissions",
    icon: <PermissionsIcon />,
    label: "Permissions",
    permission: "view_permission",
  },
  {
    to: "/dashboard/blog",
    icon: <BlogIcon />,
    label: "Blog",
    permission: null,
  },
  {
    to: "/dashboard/live/records",
    icon: <RecordingsIcon />,
    label: "Records",
    permission: "view_records",
  },
];
